import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import LoaderWrapper from '~/components/LoaderWrapper';
import ExpandableSection from '~/containers/ExpandableSection';
import DOMPurify from 'dompurify';

type ArtifactViewMainContentTechnicalTeardownInformationProps = {
  actions: object;
  artifactState: object;
  artifact: object;
};
class ArtifactViewMainContentTechnicalTeardownInformation extends React.Component<
  ArtifactViewMainContentTechnicalTeardownInformationProps,
  {}
> {
  componentDidMount() {
    let artifact = this.props.artifact,
      teardown = artifact.teardown || '';
    this.props.actions.fetchMarkdownHtml('teardown', teardown);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.artifactState.viewMode !== nextProps.artifactState.viewMode) {
      let artifact = nextProps.artifact,
        teardown = artifact.teardown || '';
      this.props.actions.fetchMarkdownHtml('teardown', teardown);
    }
  }
  render() {
    const { artifactState } = this.props;
    const { markdownHtml, isFetchingMarkdown } = artifactState;
    const { teardown: teardownHtml } = markdownHtml;
    let teardownText = null;
    if (teardownHtml) {
      teardownText = (
        <div
          className="markdown--artifact"
          //eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(teardownHtml) }}
        />
      );
    }
    return (
      <section className="pb phone--p0">
        <LoaderWrapper
          isLoaderShowing={isFetchingMarkdown['teardown']}
          loaderType="SPINNER"
          loaderClassName="text--center"
        >
          {teardownText ? (
            <ExpandableSection
              id="teardown-section"
              isExpandedByDefault={false}
              collapsedHeightClass={`height--205`}
            >
              {teardownText}
            </ExpandableSection>
          ) : (
            'No teardown information available'
          )}
        </LoaderWrapper>
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentTechnicalTeardownInformation);
